<template>
  <div class="ControlsShape__Container">
    <div class="ControlsShape__SliderContainer">
      <p class="ControlsShape__Text">
        C1
      </p>
      <input
        type="range"
        ref="slider04"
        step="0"
        min="-12"
        max="12"
        class="ControlsShape__Slider"
        v-model="s04"
        :style="gradientS04"
        @input="ValueChanged()"
        @mousedown="Focus(3)"
        @touchstart="Focus(3)"
        @mouseover="Focus(3)"
        @mouseleave="EndDrag()"
      >
      <p class="ControlsShape__Text">
        {{ textFormat(s04) }}
      </p>
    </div>
    <div class="ControlsShape__SliderContainer">
      <p class="ControlsShape__Text">
        C2
      </p>
      <input
        type="range"
        ref="slider03"
        step="0"
        min="-12"
        max="12"
        class="ControlsShape__Slider"
        v-model="s03"
        :style="gradientS03"
        @input="ValueChanged()"
        @mousedown="Focus(2)"
        @touchstart="Focus(2)"
        @mouseover="Focus(2)"
        @mouseleave="EndDrag()"
      >
      <p class="ControlsShape__Text">
        {{ textFormat(s03) }}
      </p>
    </div>
    <div class="ControlsShape__SliderContainer">
      <p class="ControlsShape__Text">
        C3
      </p>
      <input
        type="range"
        ref="slider02"
        step="0"
        min="-12"
        max="12"
        class="ControlsShape__Slider"
        v-model="s02"
        :style="gradientS02"
        @input="ValueChanged()"
        @mousedown="Focus(1)"
        @touchstart="Focus(1)"
        @mouseover="Focus(1)"
        @mouseleave="EndDrag()"
      >
      <p class="ControlsShape__Text">
        {{ textFormat(s02) }}
      </p>
    </div>
    <div class="ControlsShape__SliderContainer">
      <p class="ControlsShape__Text">
        C4
      </p>
      <input
        type="range"
        ref="slider01"
        step="0"
        min="-12"
        max="12"
        class="ControlsShape__Slider"
        v-model="s01"
        :style="gradientS01"
        @input="ValueChanged()"
        @mousedown="Focus(0)"
        @touchstart="Focus(0)"
        @mouseover="Focus(0)"
        @mouseleave="EndDrag()"
      >
      <p class="ControlsShape__Text">
        {{ textFormat(s01) }}
      </p>
    </div>
    <div
      class="Buttons__Container"
    >
      <div
        class="Buttons__Left"
        @click="Reset()"
      >
        <p class="Buttons__Left__Text">
          {{ $t('button-reset') }}
        </p>
      </div>
      <div class="Buttons__Spacing" />
      <div
        class="Buttons__Right"
        @click="NextStep()"
      >
        <p class="Buttons__Right__Text">
          {{ $t('button-validate') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'

// slider styling : https://codepen.io/dmalashock/pen/LJuym

export default {
  data () {
    return {
      s01: 0,
      s02: 0,
      s03: 0,
      s04: 0
    }
  },
  computed: {
    ...mapGetters(['curve01', 'curve02', 'curve03', 'curve04', 'highlightedSlider']),
    gradientS01 () {
      return (this.GetSliderStyling(this.s01, 0))
    },
    gradientS02 () {
      return (this.GetSliderStyling(this.s02, 1))
    },
    gradientS03 () {
      return (this.GetSliderStyling(this.s03, 2))
    },
    gradientS04 () {
      return (this.GetSliderStyling(this.s04, 3))
    }
  },
  mounted () {
    this.$refs.slider01.value = (this.curve01 || 0)
    this.$refs.slider02.value = (this.curve02 || 0)
    this.$refs.slider03.value = (this.curve03 || 0)
    this.$refs.slider04.value = (this.curve04 || 0)
    this.s01 = (this.curve01 || 0)
    this.s02 = (this.curve02 || 0)
    this.s03 = (this.curve03 || 0)
    this.s04 = (this.curve04 || 0)
    window.addEventListener('mouseup', this.EndDrag)
    window.addEventListener('touchend', this.EndDrag)
    this.$store.dispatch('SetHighlightedSlider', -1)
  },
  beforeDestroy () {
    window.removeEventListener('mouseup', this.EndDrag)
    window.removeEventListener('touchend', this.EndDrag)
  },
  methods: {
    GetSliderStyling (value, index) {
      const val = (parseInt(value) + 12) * 4.16
      const col = this.highlightedSlider === index ? 'rgba(255, 179, 0)' : 'black'
      if (val < 50) {
        return { background: 'linear-gradient(to right, #ebebeb 0%, #ebebeb ' + val + '%, ' + col + ' ' + val + '%, ' + col + ' ' + 50 + '%, #ebebeb 50%, #ebebeb 100%)' }
      } else {
        return { background: 'linear-gradient(to right, #ebebeb 0%, #ebebeb 50%, ' + col + ' 0%, ' + col + ' ' + val + '%, #ebebeb ' + val + '%, #ebebeb 100%' }
      }
    },
    ValueChanged () {
      this.$store.dispatch('SetSliders', [this.s01, this.s02, this.s03, this.s04])
    },
    Focus (index) {
      this.$store.dispatch('SetHighlightedSlider', index)
    },
    EndDrag () {
      this.$store.dispatch('SetHighlightedSlider', -1)
    },
    textFormat (s) {
      let val = ''
      if (s < 0) {
        val = ''
      } else if (s > 0) {
        val = '+'
      }
      return val + s + '°'
    },
    NextStep () {
      EventBus.$emit('NextStep')
    },
    Reset () {
      this.$refs.slider01.value = 0
      this.$refs.slider02.value = 0
      this.$refs.slider03.value = 0
      this.$refs.slider04.value = 0
      this.s01 = 0
      this.s02 = 0
      this.s03 = 0
      this.s04 = 0
      this.$store.dispatch('SetSliders', [0, 0, 0, 0])
    }
  }
}
</script>

<style scoped lang="scss">
.ControlsShape__Container{
  display: flex;
  flex-direction: column;
  margin: 0px 20px 10px 20px;
}

.ControlsShape__SliderContainer{
  display: flex;
  flex-direction: row;
  width: 100%;
  align-self: center;
  justify-content: space-between;
    margin: 15px 0px 15px 0px;
}

.ControlsShape__Slider {
  align-self:center;
  flex: 0.9;
  height: 2px;
}

@media screen and (min-width: 1300px) {
.ControlsShape__Text {
  align-self: center;
  font-size: 1em;
}
}

@media screen and (max-width: 1300px) {
.ControlsShape__Text {
  align-self: center;
  font-size: 0.8em;
}
}

input[type=range] {
  width: 100%;
  margin: 4.4px 0;
  background-color: transparent;
  -webkit-appearance: none;
}
input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  background: #ebebeb;
  border: 0;
  border-radius: 1.3px;
  width: 100%;
  height: 2.2px;
  cursor: pointer;
  margin-top: 1em;
  margin-bottom: 1em;
}

input[type=range]::-webkit-slider-thumb {
  margin-top: -4.4px;
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type=range]:active {
  &::-webkit-slider-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-moz-range-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-ms-thumb {
    background:rgba(255, 179, 0, 1);
  }
}

input[type=range]:hover {
  &::-webkit-slider-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-moz-range-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-ms-thumb {
    background:rgba(255, 179, 0, 1);
  }
}

input[type=range]::-webkit-slider-runnable-track {
  background: rgba(0,0,0,0)
}

input[type=range]::-webkit-slider-thumb {
  margin-top: -4.4px;
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type=range]::-moz-range-track {
background: rgba(0,0,0,0)
}

input[type=range]::-moz-range-thumb {
  margin-top: -4.4px;
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type=range]::-ms-track {
background: rgba(0,0,0,0)
}

input[type=range]::-ms-thumb {
  margin-top: -4.4px;
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

.Buttons__Container {
 width: 100%;
 height: 38px;
 margin-top: 5px;
 display: flex;
 flex-direction: row;
}

.Buttons__Left{
   width: 50%;
   display: flex;
   justify-content: center;
   border: 1px grey solid;
   border-radius: 50px;
}

.Buttons__Right{
  width: 50%;
  display: flex;
  justify-content: center;
  background: black;
  border-radius: 50px;
}

.Buttons__Left__Text {
 margin: auto;
 font-weight: 200;
 font-size: 0.9em;
}

.Buttons__Right__Text {
 color: white;
 margin: auto;
 font-size: 0.9em;
}

.Buttons__Spacing {
  width: 10px;
}
</style>
